// Public post URLs from instagram.com/eurogulfmobility (max 3 shown)
export const INSTAGRAM_POST_URLS = [
  "https://www.instagram.com/p/DaAmUnFopGn/",
  "https://www.instagram.com/p/DQ_1tY6Dh0P/",
  "https://www.instagram.com/p/DPl0WvzExD-/",
];

export const SOCIAL = {
  instagram: "https://www.instagram.com/eurogulfmobility/",
  linkedin: "https://www.linkedin.com/company/105403528/",
  facebook: "https://www.facebook.com/people/Eurogulf-Mobility-Group/61567335605176/",
};
